import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ email: "", password: "", display_name: "" });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await register(form.email, form.password, form.display_name);
      toast.success("Pilot profile initiated. Verification transmission sent!");
      localStorage.setItem("rtrl_verify_email", form.email);
      nav("/verify", { state: { email: form.email } });
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Registration failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-24">
      <div className="rtrl-card carbon-bg p-8">
        <div className="small-label text-rtrl-red">Racer Signup</div>
        <h1 className="font-display uppercase text-5xl text-white mt-2">Register</h1>
        <p className="text-white/50 text-sm mt-2">Creates your Racer profile automatically. Owners &amp; GMs are created by League Owners.</p>
        <form onSubmit={submit} className="mt-8 space-y-6">
          <div>
            <label className="small-label">Racer Name</label>
            <input data-testid="reg-name" required value={form.display_name} onChange={(e) => setForm({ ...form, display_name: e.target.value })} className="rtrl-input" />
          </div>
          <div>
            <label className="small-label">Email</label>
            <input data-testid="reg-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rtrl-input" />
          </div>
          <div>
            <label className="small-label">Password</label>
            <input data-testid="reg-password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="rtrl-input" />
          </div>
          <button data-testid="reg-submit" disabled={busy} className="rtrl-btn w-full justify-center">{busy ? "…" : "Create Racer Account"}</button>
        </form>

        <div className="mt-6 flex items-center justify-between gap-2">
          <div className="h-px bg-surface-line flex-1"></div>
          <span className="small-label text-white/40">OR</span>
          <div className="h-px bg-surface-line flex-1"></div>
        </div>

        <button
          onClick={() => {
            // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
            const redirectUrl = window.location.origin + "/login";
            window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
          }}
          className="mt-4 rtrl-btn-ghost w-full justify-center gap-2 border border-surface-line hover:border-white/20"
          data-testid="google-auth-btn"
        >
          <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
            <path d="M12.24 10.285V14.4h6.887c-.648 2.41-2.519 4.114-5.136 4.114-3.51 0-6.357-2.847-6.357-6.357s2.847-6.357 6.357-6.357c1.5 0 2.873.515 3.96 1.39l3.079-3.08A11.91 11.91 0 0012.24 2c-6.627 0-12 5.373-12 12s5.373 12 12 12c6.244 0 11.517-4.36 12-10.285H12.24z"/>
          </svg>
          Register with Google
        </button>

        <div className="mt-6 small-label">
          Already have an account? <Link to="/login" className="text-rtrl-red">Log in</Link>.
        </div>
      </div>
    </div>
  );
}
